import { Minus, Plus, Trash2 } from "lucide-react";
import type { CartItem as CartItemType } from "@/src/types";

interface CartItemProps {
    item: CartItemType;
    onRemove: (id: string) => void;
    onUpdateQuantity: (id: string, delta: number) => void;
}

export function CartItem({ item, onRemove, onUpdateQuantity }: CartItemProps) {
    return (
        <div className="flex gap-4">
            <img
                src={item.image}
                alt={item.name}
                className="w-24 h-24 object-cover rounded-sm"
                referrerPolicy="no-referrer"
            />
            <div className="flex-1 space-y-1">
                <div className="flex justify-between">
                    <h3 className="font-medium">{item.name}</h3>
                    <button
                        onClick={() => onRemove(item.id)}
                        className="text-stone-400 hover:text-red-500"
                    >
                        <Trash2 size={16} />
                    </button>
                </div>
                <p className="text-sm text-stone-500">{item.scent}</p>
                <div className="flex justify-between items-center pt-2">
                    <div className="flex items-center border rounded-sm">
                        <button
                            onClick={() => onUpdateQuantity(item.id, -1)}
                            className="p-1 px-2 hover:bg-stone-50"
                        >
                            <Minus size={12} />
                        </button>
                        <span className="px-2 text-sm">{item.quantity}</span>
                        <button
                            onClick={() => onUpdateQuantity(item.id, 1)}
                            className="p-1 px-2 hover:bg-stone-50"
                        >
                            <Plus size={12} />
                        </button>
                    </div>
                    <p className="font-medium">£{(item.price * item.quantity).toFixed(2)}</p>
                </div>
            </div>
        </div>
    );
}
